export class BaseClassMetadata {
  constructor(props) {
    this.createdBy = '';
    this.createdByUserId = '';
    this.createdDate = '';
    this.etag = '';
    this.lastModifiedBy = '';
    this.lastModifiedByUserId = '';
    this.lastModifiedDate = '';
    this.state = '';

    Object.assign(this, props);
  }
}

export class BaseClass {
  constructor(props) {
    this.id = '';
    this.href = '';
    this.metadata = new BaseClassMetadata();
    this.type = '';

    Object.assign(this, props);
  }

  setMetadata(props) {
    Object.assign(this.metadata, props);
  }

  setBaseProperties(props) {
    Object.assign(this, props);
  }

  getProperties() {
    return this.properties;
  }

  getProperty(name) {
    return this.properties && this.properties[name];
  }

  getId() {
    return this.id;
  }

  getType() {
    return this.type;
  }

  getItems() {
    return this.items;
  }
}
